module.exports = __webpack_public_path__ + "static/media/promo-code-upload-sample.973b7253.png";